<app-sidenav>
  <h2 class="page-title mt-5 pt-2 ">Instituições em Regime Especial</h2>
  <!-- <div class="col-md-12 ml-1 mr-1"> -->
        <!-- <h2 (click)="test.toggle()">{{cardData.nome}}</h2> -->
        <!-- <div class="box col-12" [isCollapsed]="false" #test="bs-collapse" mdbCollapse> -->
          <ol class="row list-unstyled gy-3">
            <li
            *ngFor="let cardData of cardSolicitacoes"
            class="col-lg-4 col-sm-12 col-md-6 my-2">
                <div class="card p-5 mh-100 d-flex justify-content center align-items-center">
                    <div class="row card-corpo">
                        <div class="col-md-12">
                         <h2 class="card-title">{{cardData.nomeInstituicao}}</h2>
                          <h5 class="dataLiquidacao mt-2">Liquidação: {{cardData.dataLiquidacao | date: "dd/MM/yyyy"}}</h5>
                          <!-- <h5 *ngIf="cardData.nomeCorretora" class="nomeCorretora">{{cardData.nomeCorretora}}</h5> -->
                          <h5 *ngIf="cardData.nomeEmpresa" class="nomeEmpresa mt-2">{{cardData.nomeEmpresa}}</h5>

                          <div class="row mt-3 mb-3">
                            <div class="col-12">
                                <span class="ml-4 custom-link-termo"><u>{{cardData.descricaoStatusProcesso}}</u></span>
                            </div>
                          </div>
                      <div class="row">
                          <div class="col-md-12 d-flex justify-content-center">
                          <button
                          data-testid="botao-card-ordinaria"
                          id="btn-new"
                          [ngClass]="customButtonStyle(cardData.statusProcesso)"
                          (click)="realizarAcao(cardData);"
                          >
                          {{cardData.descricaoProcesso}}
                          </button>
                          <!-- tipoProcesso -->
                        </div>
                      </div>
                     </div>
                    </div>
                </div>
            </li>
        </ol>
<!-- </div> -->
<!-- exibir st Processo api está retornando -->
</app-sidenav>
